let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}



// Product dimension changer - START
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('input[name="id"]').forEach((input) => {  
    input.addEventListener("change", function () {
      window.updateDynamicProductData(this.value);
    });
  });
});

const dynamicTypes = {
  "dimension": [
    "dimensions"
  ],
  "date": [
    "available_at"
  ],
  "number": [
    "pieces"
  ]
};

window.addDynamicProductData = function (id, data) {
  if(!window.dynamicProductData.hasOwnProperty[id]) {
    window.dynamicProductData[id] = {};
  }

  for (const [type, fields] of Object.entries(dynamicTypes)) {
    for (const [key, value] of Object.entries(data)) {
      if(value && fields.includes(key)) {
        switch(type) {
          case "dimension":
            data[key] = {label: "", value: ""};
            value.forEach((entry, idx) => {
              if(parseFloat(entry.value) > 0) {
                data[key].label += (data[key].label.length > 0 ? 'x': '') + entry.label;
                data[key].value += (data[key].value.length > 0 ? ' x ': '') + entry.value;
              }
            });
            break;
          case "date":
            const days = Math.floor((new Date(value) - new Date()) / (1000 * 60 * 60 * 24));
            data[key] = new Intl.RelativeTimeFormat('de-DE', {numeric: 'always', style: 'long'}).format(days, "days");
            break;
          case "number":
            data[key] = new Intl.NumberFormat("de-DE").format(value);
            break;
        }
      }
    }
  }

  window.dynamicProductData[id] = Object.assign(window.dynamicProductData[id], data);
}

window.updateDynamicProductData = function (id) {
  if(!window.dynamicProductData || !window.dynamicProductData.hasOwnProperty(id)) return;
  Object.entries(window.dynamicProductData[id]).forEach(function(item) {
    let key = item[0], label = '', value = item[1];
    if(typeof value === "object") {
      label = item[1].label;
      value = item[1].value;
    }
    const containers = document.querySelectorAll('.' + key + '-container');
    if(containers.length && value.length > 0) {
      for (i = 0; i < containers.length; i++){
        containers[i].classList.remove('hidden');
      }
    }
    const labels = document.querySelectorAll('.' + key + '-label');
    if(labels.length && label.length > 0) {
      for (i = 0; i < labels.length; i++){
        labels[i].textContent = label;
      }
    }
    const values = document.querySelectorAll('.' + key + '-value');
    if(values.length) {
      for (i = 0; i < values.length; i++){
        values[i].textContent = value;
      }
    }
  });
}
// Product dimension changer - END